import { ActionMeta, OptionProps, Select, chakraComponents } from "chakra-react-select";
import { selectChakraStyles } from "utils/constants";
import { useEffect, useState } from "react";
import { SelectOption } from "utils/types";
import { Text, VStack } from "@chakra-ui/react";
import { monthsForStatements } from "utils/constants";

const customComponents = {
  Option: ({ children, ...props }: OptionProps) => {
    const data: {
      label: string;
    } = props.data as any;
    return (
      <chakraComponents.Option {...props}>
        <VStack alignItems="flex-start" spacing="0px">
          <Text>{data.label}</Text>
        </VStack>
      </chakraComponents.Option>
    );
  },
};

const MonthSelect = ({
  months,
  setMonths,
}: {
  months: SelectOption | null;
  setMonths: (newValue: SelectOption | null) => void;
}) => {
  const [value] = useState<SelectOption | null>(null);
  const [monthOptions, setMonthsOptions] = useState<SelectOption[] | undefined>([]);

  async function statementMonthlyOption() {
    const formattedOptions = monthsForStatements.map((month: string) => ({
      label: month,
      value: month,
    }));
    setMonthsOptions(formattedOptions);
  }

  const onChange = (newValue: SelectOption | unknown, _actionMeta: ActionMeta<unknown>) => {
    setMonths(newValue as SelectOption | null);
  };

  useEffect(() => {
    // if (user.type === "borrower") {

    // } else {
    statementMonthlyOption();
    // }
  }, [months]);

  return (
    <Select
      className="statement-select"
      isClearable={false}
      useBasicStyles
      selectedOptionColor="black"
      colorScheme="purple"
      variant="outline"
      focusBorderColor="#00000029"
      chakraStyles={selectChakraStyles}
      value={value}
      onChange={onChange}
      options={monthOptions}
      placeholder="Select a month ..."
      noOptionsMessage={() => "No Month found."}
      components={customComponents}
    />
  );
};

export default MonthSelect;
